import React from 'react';
import styles from './RASText.module.scss';

const RASText = ({
  tradeMark = false,
  shouldWrap = false,
}) => (
  <span className={shouldWrap ? '' : 'text-nowrap'}>
    Retirement Advisory Service
    {tradeMark && <sup className={styles.sup}>™</sup>}
  </span>
);

export default RASText;
